import { render, staticRenderFns } from "./AddVendorType.vue?vue&type=template&id=ac0cef08&"
import script from "./AddVendorType.vue?vue&type=script&lang=js&"
export * from "./AddVendorType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports